import { Component, OnInit, OnDestroy, ViewChild, forwardRef, ElementRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MatPaginator, MatSort, MatDialog } from "@angular/material";
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { ModuleConfiguration } from '../messages.module.config';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import { MessagesListModel } from '../models/MessagesListModel';
import { MessagesModel } from '../models/MessagesModel';
import * as fromStore from '../store/reducers';
import * as messagesActions from '../store/actions';
import { FormGroup } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { DatePipe } from '@angular/common';
import { DateFramedMessageModel } from '../models/DateFramedMessageModel';

@Component({
  selector: 'brd-messages-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => MessagesTileComponent) }],
  templateUrl: './messages-tile.component.html',
  styleUrls: ['./messages-tile.component.scss']
})
export class MessagesTileComponent extends TileComponent implements OnInit, OnDestroy {
  displayedColumns = ['message', 'expirationTimestamp', 'status'];
  loading$: Observable<boolean>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  messages: MessagesModel = new MessagesModel;
  messagesForm: FormGroup;
  broadcastMessage: string;
  broadcastStatus: string;
  datePipe: DatePipe;
  // notifications: DateFramedMessageModel[];
  activeNotifications: DateFramedMessageModel[];
  activeBroadcastMessage: DateFramedMessageModel[];
  draftBroadcastMessage: DateFramedMessageModel[];

  editMessages: string = 'ConfigurationModule.Messages:Edit';

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;

  constructor(
    private store: Store<TileState<MessagesListModel, MessagesModel>>,
    private actions$: Actions,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    elementRef: ElementRef,
    private tileContainer: TileContainer) {
    super(elementRef);
    tileContainer.tileComponents.push(this);
  }

  ngOnInit() {
    this.store.dispatch(new messagesActions.GetMessagesAction());

    this.actions$.ofType(messagesActions.GET_MESSAGES_SUCCESS_ACTION)
      .takeUntil(this.destroyed$)
      .subscribe((a: messagesActions.GetMessagesSuccessAction) => {
        // var messages = a.payload.messages;
        // if (messages != null) {
        //   this.messages = messages;
        //   if (!messages.activeBroadcastMessage) {
        //     if(messages.draftBroadcastMessage)
        //     {
        //       this.broadcastMessage = messages.draftBroadcastMessage.value;
        //       this.broadcastStatus = "Draft";
        //     }
        //   } else {
        //     this.broadcastMessage = messages.activeBroadcastMessage.value;
        //     this.broadcastStatus = "Active";
        //   }
        // }
        this.messages = a.payload.messages;
        // this.notifications = this.messages.activeNotifications;
        this.activeNotifications = this.messages.activeNotifications;
        this.activeBroadcastMessage = this.messages.activeBroadcastMessage ? [this.messages.activeBroadcastMessage] : [];
        // this.draftBroadcastMessage = this.messages.draftBroadcastMessage ? [this.messages.draftBroadcastMessage] : [];
      });
  }

  convertDateToUtc(date: Date) {
    return new Date(date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds());
  }

  edit(): void {
    this.router.navigateByUrl('messages-workspace');
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/messages/components/messages-tile.component.ts